import styled from 'styled-components'
import Skeleton from '@app.components/Skeleton'
import BookMark from 'svgIcons/BookMark'

const LOADING_ITEM_LENGTH = 20

const LoadingItemList = () => {
  const loadingItems = new Array(LOADING_ITEM_LENGTH).fill('')

  return (
    <>
      {loadingItems.map((_, index) => {
        return (
          <StyledWrapper key={`loading-item-${index}`}>
            <div className="flex-wrapper">
              <div className="block-display">
                <Skeleton width={200} height={20} className="mobile-skeleton" />
                <Skeleton width={250} height={20} className="mobile-skeleton" />
                <Skeleton width={280} height={35} className="mobile-skeleton" />
              </div>
            </div>
            <i className="scrap-icon">
              <BookMark className="bookmark-icon" />
            </i>
          </StyledWrapper>
        )
      })}
    </>
  )
}

export default LoadingItemList

const StyledWrapper = styled.div`
  background-color: white;
  padding: 20px 0;
  width: 100%;
  border-bottom: 1px solid ${({ theme }) => theme.background.bg_3};
  display: flex;
  align-items: center;
  justify-content: center;

  .flex-wrapper {
    display: flex;
    align-items: center;
    justify-content: center;
  }

  .bookmark-icon {
    color: rgba(0, 0, 0, 0.11);
    width: 15px;
  }

  .mobile-skeleton {
    margin-bottom: 5px;
  }

  .scrap-icon {
    padding: 12px;
    flex-shrink: 0;
    margin-left: 10px;
  }

  .block-display {
    display: block;
  }
`
